import React, { useState, useEffect } from 'react'
import MedicalHistorySection from '../../../components/ProfileForm/MedicalHistorySection'
import EmergencyContactInfo from './EmergencyContactInfo'

const HealthInfo = ({ data, onChange, onValidityChange, dependant }) => {
  const [userInfo, setUserInfo] = useState({
    medicalHistory: {
      allergies: { preferNotToSay: false, noKnownAllergies: false, value:'' },
      medications: { takingNone: false, preferNotToSay: false, value: '' },
      conditions: {
        noKnownConditions: false,
        preferNotToSay: false,
        value: ''
      },
    },
  })

  const [emergencyContact, setEmergencyContact] = useState({
    emergencyName: data.emergencyName || '',
    emergencyPhone: data.emergencyPhone || '',
  })

  const [consent, setConsent] = useState({
    consent: data.consent || false,
    terms: data.terms || false,
  })

  const validate = () => {
    return (
      consent.consent &&
      consent.terms &&
      emergencyContact.emergencyName.trim() &&
      emergencyContact.emergencyPhone.trim()
    )
  }

  useEffect(() => {
    const isValid = validate()
    if (typeof onValidityChange === 'function') {
      onValidityChange(isValid)
    }

    // Update parent component with current data
    onChange('emergencyName', emergencyContact.emergencyName)
    onChange('emergencyPhone', emergencyContact.emergencyPhone)
    onChange('consent', consent.consent)
    onChange('terms', consent.terms)
    onChange('medicalHistory', userInfo.medicalHistory)
  }, [userInfo, emergencyContact, consent])

  return (
    <div className="space-y-6">
      {/* Medical History Section */}
      <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-6 sm:gap-x-6">
        <MedicalHistorySection
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          showTitle={true}
          dependant={dependant}
        />
      </div>

      {/* Emergency Contact */}
      <EmergencyContactInfo
        emergencyContact={emergencyContact}
        setEmergencyContact={setEmergencyContact}
      />

      {/* Consent */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Consent</h2>

        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="consent"
              name="consent"
              required
              checked={consent.consent}
              onChange={(e) => {
                setConsent((prev) => ({ ...prev, consent: e.target.checked }))
              }}
              className="h-4 w-4 text-violet-600"
            />
            <label htmlFor="consent" className="text-sm text-gray-600">
              I consent to the storage and sharing of my {dependant && 'dependants'} data for the purpose of
              receiving wellbeing services.
            </label>
          </div>

          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="terms"
              name="terms"
              checked={consent.terms}
              onChange={(e) => {
                setConsent((prev) => ({ ...prev, terms: e.target.checked }))
              }}
              required
              className="h-4 w-4 text-violet-600"
            />
            <label htmlFor="terms" className="text-sm text-gray-600">
              I agree to the{' '}
              <a href="/privacy-policy" target="_blank" className="underline text-violet-600">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href="/terms" target='_blank' className="underline text-violet-600">
                Terms of Use
              </a>
              .
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HealthInfo
